// src/components/attorneys/FiltersSection.jsx
const STATE_OPTIONS = ["", "AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA","HI","ID","IL","IN","IA","KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA","WV","WI","WY"];
const MIN_REVIEWS_OPTIONS = [0, 5, 10, 20, 50];
const SORT_OPTIONS = [
  { value: "top", label: "Top Rated" },
  { value: "reviews", label: "Most Reviewed" },
  { value: "name", label: "Name (A–Z)" },
  { value: "ratingAsc", label: "Rating (Low→High)" },
];

const FiltersSection = ({
  filters,
  setFilters,
  filteredCount,
  totalCount,
  onReset,
}) => {
  const { searchTerm, stateFilter, cityFilter, hasOffice, minRating, minReviews, sortOption } = filters;

  return (
    <div className="rounded-3xl bg-white p-6 md:p-8 shadow-xl ring-1 ring-blue-100/60">
      <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
        <div className="flex flex-col gap-2">
          <label className="text-sm font-semibold text-gray-700">Search</label>
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setFilters(prev => ({ ...prev, searchTerm: e.target.value }))}
            placeholder="Name, email, or office"
            className="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-2 text-sm focus:border-blue-500 focus:bg-white focus:ring-2 focus:ring-blue-200"
          />
        </div>

        <div className="flex flex-col gap-2">
          <label className="text-sm font-semibold text-gray-700">State</label>
          <select
            value={stateFilter}
            onChange={(e) => setFilters(prev => ({ ...prev, stateFilter: e.target.value }))}
            className="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-2 text-sm focus:border-blue-500 focus:bg-white focus:ring-2 focus:ring-blue-200"
          >
            {STATE_OPTIONS.map((s) => (
              <option key={s || "all"} value={s}>{s || "All States"}</option>
            ))}
          </select>
        </div>

        <div className="flex flex-col gap-2">
          <label className="text-sm font-semibold text-gray-700">City</label>
          <input
            type="text"
            value={cityFilter}
            onChange={(e) => setFilters(prev => ({ ...prev, cityFilter: e.target.value }))}
            placeholder="Enter city"
            className="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-2 text-sm focus:border-blue-500 focus:bg-white focus:ring-2 focus:ring-blue-200"
          />
        </div>

        <div className="flex flex-col gap-2">
          <label className="text-sm font-semibold text-gray-700">
            Min Rating: <span className="text-blue-600">{minRating.toFixed(1)}</span>
          </label>
          <input
            type="range"
            min="0" max="5" step="0.5"
            value={minRating}
            onChange={(e) => setFilters(prev => ({ ...prev, minRating: parseFloat(e.target.value) }))}
            className="accent-blue-600"
          />
        </div>

        <div className="flex flex-col gap-2">
          <label className="text-sm font-semibold text-gray-700">Min Reviews</label>
          <select
            value={minReviews}
            onChange={(e) => setFilters(prev => ({ ...prev, minReviews: parseInt(e.target.value) }))}
            className="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-2 text-sm focus:border-blue-500 focus:bg-white focus:ring-2 focus:ring-blue-200"
          >
            {MIN_REVIEWS_OPTIONS.map(v => (
              <option key={v} value={v}>{v === 0 ? "All" : `${v}+ reviews`}</option>
            ))}
          </select>
        </div>

        <div className="flex flex-col gap-2">
          <label className="text-sm font-semibold text-gray-700">Sort By</label>
          <select
            value={sortOption}
            onChange={(e) => setFilters(prev => ({ ...prev, sortOption: e.target.value }))}
            className="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-2 text-sm focus:border-blue-500 focus:bg-white focus:ring-2 focus:ring-blue-200"
          >
            {SORT_OPTIONS.map(o => (
              <option key={o.value} value={o.value}>{o.label}</option>
            ))}
          </select>
        </div>
      </div>

      <div className="mt-6 flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <label className="inline-flex items-center gap-2 text-sm font-semibold text-gray-700">
          <input
            type="checkbox"
            checked={hasOffice}
            onChange={(e) => setFilters(prev => ({ ...prev, hasOffice: e.target.checked }))}
            className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
          />
          Has Office
        </label>

        <div className="flex flex-wrap items-center gap-3 text-xs text-gray-500">
          <span>Showing {filteredCount} of {totalCount} attorneys</span>
          <button
            onClick={onReset}
            className="inline-flex items-center rounded-full border border-blue-200 bg-blue-50 px-3 py-1.5 font-semibold text-blue-600 hover:bg-blue-100"
          >
            Reset Filters
          </button>
        </div>
      </div>
    </div>
  );
};

export default FiltersSection;